/* NOTE: Handling state management
 * Setting ticketId
 * Toggling flag for hiding showing modal */

import {
  types,
} from './actions';

const defaultState = {
  showTicketEntryFormModal: false,
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.OPEN_TICKET_ENTRY_FORM: {
      return {
        ...state,
        showTicketEntryFormModal: true,

      };
    }
    case types.CLOSE_TICKET_ENTRY_FORM: {
      return {
        ...state,
        showTicketEntryFormModal: false,
      };
    }
    default:
      return state;
  }
};

export default reducer;
